










































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import images from "./image";

@Component
export default class ProductCoverDialog extends Vue {
  @Prop() private info!: object;
  @Prop() private onCoverhandleOk!: () => void;
  @Prop() private onCoverhandleCancel!: () => void;
  public data() {
    return {
      tapType: "0",
      loading: false,
      showGallery: false,
      images,
      specVal: 0,
      classVal: 0,
      list: [],
      currIndex: undefined,
      searchData: {
        activity_id: 14,
        page: 1,
        page_size: 12,
        cate_id: null,
      },
      jdTotal: 12, // 图片总数
      JdCateList: [], // 京东分类
      jdGoodsList: [], // 京东分类下商品
      isShowGoodsList: false,
    };
  }

  public created() {
    if (this.$data.tapType == "0") {
      this.$data.list = this.getGalleryList(
        this.$data.specVal,
        this.$data.classVal
      );
    } else if (this.$data.tapType == "1") {
      this.getCate({});
    }
  }
  public tapClick(e: any) {
    this.$data.currIndex = null;
    this.$data.isShowGoodsList = false;
    if (e.name == "1") {
      this.getCate({});
    }
  }
  public refesh() {
    this.getCate({});
  }
  public async getCate(e: any) {
    try {
      this.$data.loading = true;
      const res = await this.$store.dispatch(
        "getCategory",
        Object.assign(
          {},
          {
            activity_id: 14,
          },
          e
        )
      );
      console.log(this, this.$data);
      this.$data.JdCateList = res;
      this.$data.loading = false;
    } catch (error) {
      this.$data.loading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }
  public folderClick(e: any) {
    this.$data.jdGoodsList = [];
    this.$data.searchData.cate_id = e.cate_id;
    this.getOtherGoodList();
  }
  public async getOtherGoodList() {
    this.$data.loading = true;
    this.$data.isShowGoodsList = true;
    try {
      const res = await this.$store.dispatch(
        "getImageList",
        this.$data.searchData
      );
      this.$data.jdTotal = res.total;
      this.$data.jdGoodsList = res.list.map((item: { picture_url: string }) => {
        item.picture_url = `http://img30.360buyimg.com/cms/${item.picture_url}`;
        return item;
      });
      this.$data.loading = false;
    } catch (error) {
      this.$data.loading = false;
      (this as any).$message.error(error.msg || error.message || error);
    }
  }
  public getGalleryList(specVal: any, classVal: any) {
    const list = images.images;
    let arr = [];
    if (classVal == 0) {
      arr = list.filter((item) => item.spec == specVal);
    } else {
      arr = list.filter(
        (item) => item.spec == specVal && item.class == classVal
      );
    }
    return arr;
  }
  public jdPagSizeChange(val: any) {
    this.$data.searchData.page = val;
    this.getOtherGoodList();
  }
  public changeGallery() {
    this.$data.showGallery = !this.$data.showGallery;
  }

  public specValChange(value: any) {
    this.$data.specVal = value;
    this.$data.list = this.getGalleryList(value, this.$data.classVal);
  }

  public classValChange(value: any) {
    this.$data.classVal = value;
    this.$data.list = this.getGalleryList(this.$data.specVal, value);
  }

  public onSelectGallery(item: any, index: any) {
    if (this.$data.tapType == "0") {
      this.$props.info.cover = item.src;
    } else {
      this.$props.info.cover = item.picture_url;
    }
    this.$data.currIndex = index;
    this.$props.info.currIndex = index;
  }
}
